
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';
import itemMixin from '@/minix/itemMixin';

const { productTag } = api;

@Component({ components: {} })
export default class ApplyProducts extends Mixins(Vue.extend(itemMixin)) {
  private tagId: number = 0;

  private data = { data: [], totalCount: 0, pageSize: 8, pageNo: 0 };

  private loading = false;

  tagSelect: SelectItem<number>[] = [];

  private panel = 0;

  private headers = [
    { text: '類型', value: 'productTypeName', width: '15%' },
    { text: '品項名稱', value: 'productName', width: '75%' },
    { text: '刪除', value: 'delete', width: '10%' },
  ];

  private productTypes = [
    { text: '全部', value: '255' },
    { text: '商品', value: '1' },
    { text: '點數', value: '2' },
    { text: '折價券', value: '4' },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private get tagName() {
    return this.tagSelect.find((p: any) => p.value === this.tagId)?.text;
  }

  private filter = {
    productType: this.$route.query.productType ? this.$route.query.productType : '255',
    productName: this.$route.query.productName ? this.$route.query.productName : '',
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async handleOpenDelete(productId: any) {
    await Swal.fire(
      {
        title: '您確定要刪除嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status, message } = await productTag.deleteApplyProduct(this.tagId, productId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: message });
        }
      }
    });
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      productType: '255',
      productName: '',
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await productTag.applyProductList(this.tagId, this.filter);
    this.data = data;
    this.loading = false;
  }

  private setTagId(id: number) {
    this.tagId = id;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: ApplyProducts) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      const { tagId } = to.params;
      vm.setTagId(+tagId);
      await vm.requestData();
    });
  }
}
